export enum NOTIFICATION_STATUS {
	NEW = 'NEW',
	UPLOADED = 'UPLOADED',
	CHECKED = 'CHECKED',
	READED = 'READED',
}
